import { ThemeInterface } from './theme-interface';
import { BaSeColors, BaSeGradients } from './colors';
import { BaSeShadows } from './shadows';
import { BaSeTransitions } from './transitions';
import { BaSeTypography } from './typography';
import { BaSeBreakpoints } from './breakpoints';
import { BaSeComponents } from './components';
import { BaSeStackOrder } from './stack-order';

export const BaSeTheme: ThemeInterface = {
  colors: BaSeColors,
  gradients: BaSeGradients,
  shadows: BaSeShadows,
  typography: BaSeTypography,
  transitions: BaSeTransitions,
  breakpoints: BaSeBreakpoints,
  components: BaSeComponents,
  stackOrder: BaSeStackOrder,
};
